export default "__VITE_ASSET__23de2f64__"